'use client';

import { t } from '@insta-club/translations';
import { CustomVideo, ReelsDescription } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import Image from 'next/image';
import { memo, useState } from 'react';

interface VideoStyle {
    id: number;
    title: string;
    thumbnail: string;
    postType: {
        id: number;
        name: string;
        type: string;
        subject: string;
        full_name: string;
    };
    video: {
        url: string;
        hls: string;
    };
}

interface Props {
    item: VideoStyle;
}

const VideoStyleGuide: React.FC<Props> = ({ item }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className='relative h-full w-full cursor-pointer bg-black'>
            <div
                onClick={() => setExpanded(false)}
                className={cn('absolute inset-x-0 bottom-0 z-30 bg-gradient-to-t from-black to-transparent', {
                    'pointer-events-auto top-0': expanded,
                    'pointer-events-none h-1/3': !expanded
                })}
            />

            <MemoizedVideoStyleContent item={item} />

            <div className='absolute inset-x-0 bottom-8 z-50 flex flex-col gap-2 px-4 text-white'>
                <div className='flex items-center gap-3'>
                    <div className='h-9 w-9 rounded-full border-2 border-gray-400 bg-white p-1'>
                        <Image alt={t('insta_club')} src='/icons/logo.png' width={36} height={36} />
                    </div>
                    <span>{t('insta_club')}</span>
                </div>
                {item.title ? (
                    <ReelsDescription text={item.title} isExpanded={expanded} onExpanded={setExpanded} />
                ) : null}
            </div>
        </div>
    );
};

export default VideoStyleGuide;

interface VideoContentProps {
    item: VideoStyle;
}

const VideoStyleContent: React.FC<VideoContentProps> = ({ item }) => {
    if (item.video) {
        return <CustomVideo hlsUrl={item.video?.hls} mp4Url={item.video?.url} disableProgress={false} showProgress />;
    }

    return null;
};

const MemoizedVideoStyleContent = memo(VideoStyleContent);

